import React, { Fragment, useEffect, useState } from "react";
import {
  CssBaseline,
  ThemeProvider,
  Theme,
  StyledEngineProvider,
  adaptV4Theme,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import DateFnsUtils from "@date-io/date-fns";

import "./App.css";
import Main from "./main/Main";
import { colorPrimary, colorSecond, colorText } from "./components";
declare global {
  interface Window {
    naver: any;
    gtag: any;
  }
}

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

window.gtag = window.gtag || {};

window.naver = window.naver || {};

const fontFamily = "NotoSansKR";
const fontSize = 13;
const fontWeight = 500;
const letterSpacing = -0.46;

const tableHeadBackgroundColor = "rgba(127, 127, 127, 0.03)";

const theme = createTheme(
  adaptV4Theme({
    palette: {
      primary: {
        main: colorPrimary,
      },
      secondary: {
        main: colorSecond,
      },
      text: {
        primary: colorText,
      },
    },
    typography: {
      fontFamily: ['"NotoSansKR"', '"Roboto"'].join(","),
      fontSize: 13,
    },
    overrides: {
      MuiInput: {
        underline: {
          "&:before": {
            borderBottomColor: "#d0d8e6",
          },
        },
      },
      MuiInputBase: {
        input: {
          height: "auto",
          padding: "6px 0 8px", // TextField에서 텍스트와 밑에 보더 사이 간격 줄이기
          fontFamily,
          fontSize,
          fontWeight,
          letterSpacing,
        },
      },
      MuiInputLabel: {
        asterisk: {
          color: colorPrimary,
        },
      },
      MuiFormLabel: {
        root: {
          fontFamily,
          letterSpacing,
        },
        asterisk: {
          color: colorPrimary,
        },
      },
      MuiRadio: {
        root: {
          padding: 0,
        },
      },
      MuiButton: {
        root: {
          padding: 0,
          borderRadius: 2, // 버튼이 각지게 만들기 위함
          fontFamily,
          fontSize,
          fontWeight,
          letterSpacing,
        },
      },
      MuiSelect: {
        select: {
          paddingLeft: 0, // select에 text 가 맨 왼쪽에 붙어 있어서 패딩을 줌
        },
      },
      MuiDialogContent: {
        root: {
          "&:first-child": {
            paddingTop: 0, // 운송 조회 상세 상단부 패딩을 없애기 위함
          },
        },
      },
      MuiTableHead: {
        root: {
          backgroundColor: tableHeadBackgroundColor,
        },
      },
      MuiTableCell: {
        root: {
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 18,
          lineHeight: 2,
          fontFamily,
          fontSize: 12,
          letterSpacing,
        },
      },
      MuiTypography: {
        body1: {
          fontSize: 13,
          fontWeight: 500,
        },
      },
      MuiSvgIcon: {
        root: {
          fontSize: "1.1rem",
        },
      },
    },

    // overrides: {
    //   MuiOutlinedInput: {
    //     inputMarginDense: {
    //       paddingTop: 6.5,
    //       paddingBottom: 6.5,
    //     },
    //     adornedEnd: {
    //       paddingRight: 0,
    //     },
    //   },
    //   MuiButton: {
    //     root: {
    //       fontSize: '1rem',
    //     },
    //     sizeSmall: {
    //       fontSize: '1rem',
    //     },
    //   },
    //   MuiTableCell: {
    //     sizeSmall: {
    //       fontSize: '1rem',
    //     },
    //   },
    //   // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //   // @ts-ignore
    //   MuiTimelineItem: {
    //     sizeSmall: {
    //       fontSize: '1rem',
    //     },
    //     missingOppositeContent: {
    //       '&:before': {
    //         display: 'none',
    //       },
    //     },
    //   },
    // },
  })
);

function App() {
  // useEffect(() => {
  //   console.log("APpppp 시작");
  //   window.addEventListener("popstate", () => {
  //     console.log("변경");
  //     window.gtag("event", "change", {
  //       user: "console",
  //     });
  //   });
  //   return () => {
  //     window.removeEventListener("popstate", () => {
  //       console.log("제거");
  //     });
  //   };
  // }, []);
  return (
    <Fragment>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          {/*<MuiPickersUtilsProvider utils={DateFnsUtils}>*/}
          <CssBaseline />
          <Main />
          {/*</MuiPickersUtilsProvider>*/}
        </ThemeProvider>
      </StyledEngineProvider>
    </Fragment>
  );
}

export default App;
